import { ReactElement } from 'react';
import { colors } from '~/styles/colors';

interface DesktopIconProps {
  color?: string;
  size?: number;
}

export function DesktopIcon({ color = colors.icon['primary-base'], size = 20 }: Readonly<DesktopIconProps>): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3.5" width="20" height="13" rx="1.8" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="16.5" x2="12" y2="21" />
    </svg>
  );
}
